/* Theme presentation only. The app continues to own plans, validation and signup. */
(() => {
  if (window.parkSignupStepsInstalled) return;
  window.parkSignupStepsInstalled = true;
  const originalMargins = new WeakMap();
  function applyWidth(element, value) {
    if (!originalMargins.has(element)) originalMargins.set(element, [element.style.marginInlineStart, element.style.marginInlineEnd]);
    const original = originalMargins.get(element);
    element.style.marginInlineStart = original[0];
    element.style.marginInlineEnd = original[1];
    const width = Number(value);
    element.style.maxWidth = width > 0 ? `min(100%, ${width}px)` : '';
    if (width <= 0) return;
    const alignment = getComputedStyle(element).textAlign;
    if (alignment === 'center') element.style.marginInline = 'auto';
    else if (alignment === 'right' || alignment === 'end') element.style.marginInlineStart = 'auto';
  }
  function init(panel) {
    if (panel.dataset.parkSignupReady) return;
    const form = panel.querySelector('[data-prime-form]');
    const grid = form?.querySelector('.prime-form__grid');
    const plans = form?.querySelector('.prime-form__plans');
    if (!form || !grid || !plans) return;
    panel.dataset.parkSignupReady = 'true';
    const config = JSON.parse(panel.querySelector('[data-park-signup-copy]').textContent);
    const header = document.createElement('div');
    header.className = 'park-signup-progress';
    const count = document.createElement('p');
    const heading = document.createElement('h3');
    heading.tabIndex = -1;
    header.append(count, heading);
    form.prepend(header);
    const planStep = document.createElement('div');
    const details = document.createElement('div');
    planStep.dataset.parkSignupStep = '1'; details.dataset.parkSignupStep = '2';
    const help = grid.previousElementSibling;
    if (help?.matches('.prime-cart__note')) details.append(help);
    details.append(grid);
    const next = document.createElement('button');
    next.type = 'button'; next.className = 'prime-cart__cta'; next.textContent = config.next;
    planStep.append(plans, next);
    const back = document.createElement('button');
    back.type = 'button'; back.className = 'park-signup-back'; back.textContent = config.back;
    [...form.children].filter(e => e !== header).forEach(e => details.append(e));
    const note = document.createElement('p');
    note.className = 'park-signup-payment-note';
     note.textContent = config.note;
    details.append(note, back);
    form.append(planStep, details);
    applyWidth(note, config.noteWidth);
    const inputs = [...grid.querySelectorAll('input')];
    const selectedPlan = () => plans.querySelector('input[name="plan"]:checked');
    const setStep = (step, focus = true) => {
      planStep.hidden = step !== 1; details.hidden = step !== 2;
      count.textContent = `${config.step} ${step} / 2`;
      applyWidth(count, config.stepWidth);
      const headingWidth = Number(step === 1 ? config.plansWidth : config.detailsWidth);
      applyWidth(heading, headingWidth);
      heading.textContent = step === 1 ? config.plans : config.details;
      if (focus) { heading.focus({preventScroll: true}); heading.scrollIntoView({block:'start',behavior:'auto'}); }
    };
    const continueNext = () => { if (selectedPlan()) setStep(2); };
    const updateNext = () => {
      next.disabled = !selectedPlan();
      // Keep the app's amounts and periods; omit only the requested VAT label here.
      plans.querySelectorAll('.prime-plan__price').forEach(price => {
        const label = price.textContent.replace(/\s*\(inkl\. moms\)/g, '');
        if (price.textContent !== label) price.textContent = label;
      });
    };
    // Plans arrive asynchronously from the app. Never advance before they are available.
    const observer = new MutationObserver(updateNext);
    observer.observe(plans, {childList:true,subtree:true});
    plans.addEventListener('change', updateNext);
    const unload = event => {
      if (!event.target.contains(panel)) return;
      observer.disconnect(); document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    next.addEventListener('click', continueNext);
    back.addEventListener('click', () => setStep(1));
    form.addEventListener('submit', e => {
      if (!planStep.hidden || !selectedPlan()) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (!selectedPlan()) setStep(1); else continueNext();
        return;
      }
      const invalid = inputs.find(input => !input.checkValidity());
      if (!invalid) return; // The app validates terms and owns the actual signup request.
      e.preventDefault(); e.stopImmediatePropagation();
      setStep(2); invalid.reportValidity();
    }, true);
    updateNext(); setStep(1, false);
  }
  function scan(root = document) {
    root.querySelectorAll('[data-park-signup-steps]').forEach(panel => init(panel));
  }
  scan();
  document.addEventListener('shopify:section:load', e => scan(e.target));
})();
